import React from 'react';
import Loader from 'src/components/Loader';
import { AuthLogo } from './AuthLogo';
import { AnimatedDots } from './EnhancedLoadingStates';

interface RedirectProcessingScreenProps {
  readonly message?: string;
  readonly submessage?: string;
}

/**
 * Redirect Processing Screen Component
 *
 * Displays a branded loading screen while processing authentication redirects.
 * Used during the redirect flow to provide user feedback and maintain branding.
 */
export const RedirectProcessingScreen: React.FC<
  RedirectProcessingScreenProps
> = ({
  message = 'Processing authentication...',
  submessage = 'Please wait while we complete your sign-in',
}) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-True-Blue to-Blue-Text">
      <div className="text-center p-8 bg-white rounded-lg shadow-lg max-w-md mx-4">
        {/* Logo */}
        <div className="mb-6">
          <AuthLogo size="lg" withBottomMargin />
        </div>

        {/* Loading Spinner */}
        <div className="mb-6">
          <Loader />
        </div>

        {/* Messages */}
        <h2 className="text-xl font-semibold text-Charcoal mb-2">{message}</h2>

        <p className="text-Informational-Text text-sm mb-6">{submessage}</p>

        {/* Animated Dots */}
        <AnimatedDots variant="bounce" size="sm" />
      </div>
    </div>
  );
};

export default RedirectProcessingScreen;
